<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>招聘类型管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateDialog()">
          新增招聘类型
        </v-btn>
      </v-col>
    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="recruitmentTypes"
      :items-per-page="5"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeleteConfirm(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-recruitment-type-popup 
    ref="createPopup"
    @type-created="refresh"
    ></create-recruitment-type-popup>
    
    <edit-recruitment-type-popup
      ref="editPopup"
      :item="selectedType"
      @type-updated="refresh"
    ></edit-recruitment-type-popup>

    <delete-recruitment-type-confirmation
      ref="deleteConfirmation"
      :item="selectedType"
      @type-deleted="refresh"
    ></delete-recruitment-type-confirmation>
  </v-container>
</template>

<script>
import { dropdownOptionsApi } from '@/api/dropdownOptions';

export default {
  components: {
    CreateRecruitmentTypePopup: () => import('@/components/recruitmentType/CreateRecruitmentTypePopup.vue'),
    DeleteRecruitmentTypeConfirmation: () => import('@/components/recruitmentType/DeleteRecruitmentTypeConfirmation.vue'),
    EditRecruitmentTypePopup: () => import('@/components/recruitmentType/EditRecruitmentTypePopup.vue')
  },
  created() {
    this.fetchRecruitmentTypes();
  },
  data() {
    return {
      headers: [
        { text: "类型名称", value: "name" },
        { text: "国内类型", value: "domestic" },
        { text: "操作", value: "actions", sortable: false },
      ],
      recruitmentTypes: [],
      selectedType: {"name": "", "createdDate": ""},
      loading: false,
    }
  },
  methods: {
    showEditDialog(item) {
      this.selectedType = item;
      this.$refs.editPopup.open(item);
    },
    showDeleteConfirm(item) {
      this.selectedType = item;
      this.$refs.deleteConfirmation.open();
    },
    
    async refresh() {
      this.fetchRecruitmentTypes();
    },

    showCreateDialog() {
      this.$refs.createPopup.open();
    },

    async fetchRecruitmentTypes() {
      this.loading = true;
      try {
        const response = await dropdownOptionsApi.getRecruitmentTypes();
        this.recruitmentTypes = response.data.map(recruitmentType => ({
          ...recruitmentType,
          id: recruitmentType.id,
          name: recruitmentType.name
        }));
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取分类列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin-right: 8px;
}
</style>